"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckboxState = void 0;
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
const useCheckboxState = function () {
  let isDefaultChecked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let isChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let onChange = arguments.length > 2 ? arguments[2] : undefined;
  const [isStateChecked, setIsStateChecked] = (0, _reactUseControlledState.default)(isDefaultChecked, isChecked, onChange);
  const handleChange = e => {
    setIsStateChecked(e.currentTarget.checked);
  };
  const handleClick = e => {
    e.stopPropagation();
  };
  return {
    isChecked: isStateChecked,
    onChange: handleChange,
    onClick: handleClick
  };
};
exports.useCheckboxState = useCheckboxState;
//# sourceMappingURL=useCheckboxState.js.map